import { AfterViewInit, Component, OnInit, signal, WritableSignal, ViewChild, ChangeDetectorRef } from '@angular/core';
import { InputComponent } from "../../shared/input/input.component";
import { SelectedComponent } from "../../shared/selected/selected.component";
import { AbstractControl, FormControl, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl, Title } from '@angular/platform-browser';
import { SecurityService } from '../../services/security.service';
import { ConfigBirthDate, ConfigInput, ConfigSelected, Department } from '../../interfaces/interfaces';
import { BirthdateComponent } from "../../shared/birthdate/birthdate.component";
import { adultValidator } from 'app/config/functions.shared';
import { CommonModule } from '@angular/common';
import { LoaderService } from '../../services/loader.service';
import { ModalComponent } from "../../shared/modal/modal.component";
import { ListsService } from '../../services/lists.service';
import { from, lastValueFrom } from 'rxjs';
import { ErrorScreenComponent } from "../../shared/error-screen/error-screen.component"; // Importación añadida
import { LogRedebanSoyyoService } from '../../services/log-redeban-soyyo.service';
import { RouteService } from '../../services/route.service';
import { HelpService } from '../../services/help.service';
import { WowComponent } from "app/shared/wow/wow.component";
import { OlimpiaService } from '../../services/olimpia.service';
import { AutocompleteComponent } from 'app/shared/autocomplete/autocomplete.component';


@Component({
  selector: 'app-form-data-basic',
  imports: [
    InputComponent,
    SelectedComponent,
    BirthdateComponent,
    ReactiveFormsModule,
    CommonModule,
    ModalComponent,
    ErrorScreenComponent,
    WowComponent,
    FormsModule,
  ],
  templateUrl: './form-data-basic.component.html',
  styleUrl: './form-data-basic.component.css'
})
export class FormDataBasicComponent implements OnInit, AfterViewInit {

  dataInputs: WritableSignal<ConfigInput[]> = signal([
    { label: 'Número de Identificación', subLabel: '(Debes seleccionar primero el tipo de identificación)', formName: 'identification', placeholder: '', type: 'tel', defaultValue: '', enabled: true, validation: [Validators.required, Validators.min(100000), Validators.max(10000000000)], textError: 'Debes digitar un número de identificación válido sin espacios ni separadores de miles.' },
    { label: 'Número de Celular', subLabel: '(para enviar códigos de seguridad)', formName: 'phone', placeholder: '', type: 'tel', defaultValue: '', enabled: true, validation: [ Validators.required, Validators.min(3000000000), Validators.max(3999999999)], textError: 'Tu numero debe tener 10 dígitos sin espacios.'},
    { label: 'Correo electrónico', subLabel: '', formName: 'email', placeholder: '', type: 'email', defaultValue: '', enabled: true, validation: [ Validators.required, Validators.email, this.miValidadorExtra], textError: 'Debes digitar un correo válido.'},
  ])

  dataSelected: WritableSignal<ConfigSelected[]> = signal([
        { label: 'Tipo de Identificación', subLabel: '', formName: 'identificationType', placeholder: '', type: 'text', defaultValue: '', enabled: true, validation: [ Validators.required], textError: 'Por favor selecciona un elemento de la lista', options: signal([{ value: 1, label: 'Cédula de Ciudadanía' }, { value: 2, label: 'Cédula de Extranjería' }]) }, // { value: 5, label: 'Pasaporte' }, { value: 48, label: 'Permiso de Protección temporal'}
    ])

  birthdateConfig = signal<ConfigBirthDate>({
    label: 'Fecha de nacimiento',
    subLabel: '',
    defaultValue: null,
    enabled: true,
    validation: [Validators.required, adultValidator],
  });

  showWowSignal: WritableSignal<boolean> = signal(false);
  showOlimpiaSignal: WritableSignal<boolean> = signal(false);

  requiredValidator = null;

  form: FormGroup;
  currentStep = 1;
  step:number | null = null;
  @ViewChild(BirthdateComponent) birthdateComponent!: BirthdateComponent;
  titleError: string = '';
  descriptionError: string = '';
  nextRoute: WritableSignal<string> = signal('');

  // Signals
  showTerms = signal(false);
  showModal = signal(false);
  recentlyOnboarding = signal(false);
  showAlert = signal(false);
  showError = signal(false);
  showBirthdateModal = signal(false);
  validatePerson = signal(false);
  showFaceGuide = signal(false);

  disabledButton = false;

  emailValidate = false;
  canContinue = true;
  hasValidationPerson = false;
  checkpoint:string = '';

  private soyYoServicePercent = 90;

  validationOlimpiaUrl: SafeResourceUrl = '';
  intervalId: any;
  processGuid: string = '';
  validateWithOlimpia = false;
  olimpiaData: any = null;
  listDepartments: Department[] = [];

  selectedDepartment: Department | null = null;
  private lastOnboardingReplication: Promise<void> | null = null;
  private isAdvancingAfterWow = false;

  constructor(
    private _router: Router,
    private title: Title,
    private _securityService: SecurityService,
    private _loaderService: LoaderService,
    private _logRedebanSoyyoService: LogRedebanSoyyoService,
    private _listsService: ListsService,
    private _routeService: RouteService,
    private _helpService: HelpService,
    private _cdr: ChangeDetectorRef,
    private olimpiaService: OlimpiaService,
    private sanitizer: DomSanitizer,

  ){
    this.title.setTitle('Onboarding Digital | Datos Básico');


    this.form = new FormGroup({
        identificationType: new FormControl(null, Validators.required),
        identification: new FormControl(null, Validators.required),
        phone: new FormControl(null, Validators.required),
        email: new FormControl(null, Validators.required),
        birthday: new FormControl(null, Validators.compose([
          Validators.required,
          this.mustBe18YearsOrOlder.bind(this),
        ])),
        authorization: new FormControl(null, Validators.compose([
          Validators.requiredTrue
        ])),
      });

      this.form.get('birthday')?.valueChanges.subscribe((value: string | null) => {
        if (value) {
          setTimeout(() => {
            const birthdayControl = this.form.get('birthday');
            if (birthdayControl?.hasError('under18')) {
              birthdayControl.setValue(null);
            }
          });
        }
      });

    this.nextRoute.set(this._routeService.getNextRoute(this._router.url) ?? '');
  }

  mustBe18YearsOrOlder(control: AbstractControl): ValidationErrors | null {
    if (control.value !== undefined && control.value !== null && control.value !== '') {
      const dateValue = new Date(control.value);
      const now = new Date();
      const minimumAge = new Date();
      minimumAge.setFullYear(now.getFullYear() - 18);

      if (dateValue > minimumAge) {
        return { under18: true };
      }
    }
    return null;
  }

  async ngOnInit(){
    const authRoute = localStorage.getItem('route');
    if(!authRoute) {
      this._router.navigateByUrl('');
    }
    const currentUrl = this._router.url;
    if(authRoute && currentUrl !== authRoute) {
      await this._router.navigateByUrl(authRoute);
    } else{
      this._helpService.show();
      this.getData();
      const consultorUser = localStorage.getItem('consultor');
      await this._securityService.getConsultorPercents(consultorUser!)
        .subscribe({
          next: async (response: any) => {
            if(response) {
              const responseData = response.percents;
              this.soyYoServicePercent = responseData.soyYoService;
            }
          },
          error: async (error: any) => {
          }
        });
    }
  }

  miValidadorExtra(control: AbstractControl): ValidationErrors | null {
    const value: string = control.value;

    if (!value) return null;

    // Expresión regular para validar que el correo termine en punto seguido de un TLD válido
    // Acepta correos que terminen en .algo donde "algo" son letras (mínimo 2 caracteres)
    const emailTldRegex = /\.([a-zA-Z]{2,})$/;

    if (!emailTldRegex.test(value)) {
      return { tldInvalido: true };
    }

    return null;
  }

  async checkPercentages() {
    const consultorUser = localStorage.getItem('consultor');
    await this._securityService.getConsultorPercents(consultorUser!)
      .subscribe({
        next: async (response: any) => {
          if(response) {
            const responseData = response.percents;
            this.soyYoServicePercent = responseData.soyYoService;
            this.showFaceGuide.set(true)
            this.selectService();
          }
        },
        error: async (error: any) => {
        }
      });
  }

  selectService() {
    const randomValue = Math.random() * 100;
    if (randomValue < this.soyYoServicePercent) {
      this.onSubmitOlimpia();
    } else {
      this.onSubmitOlimpia();
    }
  }

  async getCheckpoint() {
    this._loaderService.show('Validando información, por favor espere...');
      this._securityService.getCheckpoint().subscribe({
        next: (response: any) => {
          this._loaderService.hide();
          this.checkpoint = response?.checkpoint ?? ''
          this.showModalNext();

        },
        error: (error: any) => {
          console.error(error);
          this._loaderService.hide();
        }
      });
  }

  showModalNext(){
    const stepCheckpoint = Number(this.checkpoint.slice(-2));

    if(stepCheckpoint > 4){
      this.next();
    }else{
      this.showModal.set(true);
    }
  }

  ngAfterViewInit(): void {
    this._loaderService.hide();
  }

  handleSelect(event: {formName: string, value: string | number}) {
    this.form.get(event.formName)?.setValue(event.value);
  }

  async hideWow(){
    if (this.isAdvancingAfterWow) {
      return;
    }

    this.isAdvancingAfterWow = true;
    this._loaderService.show('Preparando tus datos, por favor espere...');
    try {
      // Solo espera la réplica disparada al aprobar identidad. El trofeo de
      // /app/address y el resto de pantallas no deben volver a copiar datos.
      await this.replicateLastOnboarding();
      this.showWowSignal.set(false);
      localStorage.setItem('route', this.nextRoute());
      await this._router.navigateByUrl(this.nextRoute());
    } finally {
      this._loaderService.hide();
      this.isAdvancingAfterWow = false;
    }
  }

  private replicateLastOnboarding(): Promise<void> {
    if (this.lastOnboardingReplication) {
      return this.lastOnboardingReplication;
    }

    this.lastOnboardingReplication = lastValueFrom(
      this._securityService.findOnBoardingByIdenfitication()
    ).then(() => undefined).catch((error) => {
      console.error('Error replicando último onboarding:', error);
    });

    return this.lastOnboardingReplication;
  }

  hideOlimpia(){
    this.showOlimpiaSignal.set(false);
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  async next() {
    localStorage.setItem('route', this.nextRoute());
    await this._router.navigateByUrl(this.nextRoute());
  }

  handleBirthdate(event: { year: string; month: string; day: string } | null) {
    if (!event) {
      this.form.get('birthday')?.setValue(null);
      this.form.get('birthday')?.updateValueAndValidity();
      return;
    }

    const month = String(event.month).padStart(2, '0');
    const day = String(event.day).padStart(2, '0');
    const birthdayValue = `${event.year}-${month}-${day}`;
    this.form.get('birthday')?.setValue(birthdayValue);
    this.form.get('birthday')?.updateValueAndValidity();

    setTimeout(() => {
      const birthdayControl = this.form.get('birthday');
      if (birthdayControl?.hasError('under18')) {
        this.showBirthdateModal.set(true);
      }
    });
  }

  handleValue(event: {formName:string, value:string | number}) {
    this.form.get(event.formName)?.setValue(event.value);
  }

  //Get Functions
  getData(){
    this._securityService.getTypedPersonData().subscribe({
      next: (response: any) => {
        this.step = Number(response?.checkpoint?.split('_')[response?.checkpoint?.split('_')?.length - 1]);
        if(response?.identificationType && response?.identification && response?.phone && response?.email) {

          setTimeout(() => {

            this.form.patchValue({
              identificationType: response.identificationType,
              identification: response.identification,
              phone: response.phone,
              email: response.email,
              birthday: response.birthday ?? null,
            }, { emitEvent: false });

          if (response.birthday) {
            const [year, month, day] = String(response.birthday).split('-');
            this.birthdateConfig.set({
              label: 'Fecha de nacimiento',
              subLabel: '',
              defaultValue: year && month && day
                ? {
                    year: Number(year),
                    month: Number(month),
                    day: Number(day),
                  }
                : null,
              enabled: !(this.step && this.step > 3),
              validation: [Validators.required, adultValidator],
            });
          }
          }, 1000);

          this.dataInputs.update((inputs:any) =>
            inputs.map((input:any) => {
              const value = (response as any)[input.formName];
              return {
                ...input,
                defaultValue: value !== undefined ? value : input.defaultValue
              };
            })
          );

          this.dataSelected.update((selects:any) =>
            selects.map((selected:any) => {
              const value = (response as any)[selected.formName];
              return {
                ...selected,
                defaultValue: value !== undefined ? value : selected.defaultValue
              };
            })
          );

          if(this.step && this.step > 3) {
            this.form.patchValue({
              authorization: true,
            });

            this.form.get('authorization')?.disable();

            const disabledInputs = this.dataInputs().map((input: any) => ({
              label: input.label,
              subLabel: input.subLabel,
              formName: input.formName,
              placeholder: input.placeholder,
              type: input.type,
              defaultValue: input.defaultValue,
              enabled: false, // Forzar a false
              validation: input.validation,
              textError: input.textError
            }));
            this.dataInputs.set(disabledInputs);

            const disabledSelects = this.dataSelected().map((select: any) => ({
              label: select.label,
              subLabel: select.subLabel,
              formName: select.formName,
              placeholder: select.placeholder,
              type: select.type,
              defaultValue: select.defaultValue,
              enabled: false, // Forzar a false
              validation: select.validation,
              textError: select.textError,
              options: select.options
            }));
            this.dataSelected.set(disabledSelects);

            this.birthdateConfig.update((config) => ({
              ...config,
              enabled: false,
            }));

            setTimeout(() => {
              this._cdr.detectChanges();
            }, 0);

            this.emailValidate = true;
            if(this.step === 6) {
              this.canContinue = false;
            }
            this.hasValidationPerson = true;
          }
        }
      },
      error: (error: any) => {
        console.error('Error fetching typed person data', error);
      }
    })
  }

  async validateOnboardingToday(){
      this._loaderService.show('Validando información, por favor espere...');
      const identification = this.form.get('identification')?.value as string
      this._securityService.validateOnboardingTodayByIdentification(identification).subscribe({
        next: (response: any) => {
          if(response.findToday == true){
            this.recentlyOnboarding.set(true);
            this._loaderService.hide();
          }else{
            this.recentlyOnboarding.set(false);
            this._loaderService.hide();
          }
        },
        error: (error:any) => {
            console.error(error)
            this._loaderService.hide();
        }
      })
    }

    async onSaveData(){
      this._loaderService.show('Validando información, por favor espere...');

      const identification = this.form.value.identification;
      const email = this.form.value.email;
      const phone = this.form.value.phone;
      const identificationType = this.form.value.identificationType;
      let documentType = 'CC';
      switch(identificationType) {
        case '1':
          documentType = 'CC';
          break;
        case '2':
          documentType = 'CE';
          break;
        case 1:
          documentType = 'CC';
          break;
        case 2:
          documentType = 'CE';
          break;
        default:
          documentType = 'CC';
          break;
      }
      try {
        this.saveData(identificationType, identification, email, phone, this.form.value.birthday);

      } catch (error:any) {

        if(error?.error?.err == 'nationality is blocked'){
          this.failMessage('A007-F: No se puede realizar su actualización por este canal, por favor acérquese a una oficina o comuníquese con su asesor...');
          this.saveLog('Error', '00-nationality is blocked', null);
          this.ngOnInit();
          return;
        }

      }
      this.validateOnboardingToday();


  }

  saveLog(step: string, message: string, data: any) {
    this._logRedebanSoyyoService.setLogRedebanSoyyo(step, message, data).subscribe({
      next: (response: any) => {
      },
      error: (error: any) => {
        this.validatePerson.set(true);
      }
    });
  }

  failMessage(description:string, title:string = 'Error') {
    this.titleError = title;
    this.descriptionError = description;
    this.showError.set(true);
    this.disabledButton = false;
    this._loaderService.hide();
  }

  saveData(identificationType: string | number, identification: string, email: string, phone: string, birthday?: string | null) {
    this._loaderService.show('Validando información, por favor espere...');
    return new Promise((resolve, reject) => {
      this._securityService.setTypedPersonDataUpdating(identificationType, identification, email, phone, birthday)
        .subscribe({
          next: async (response: any) => {
            resolve(response);
            this._loaderService.hide();

            // CAMBIAR DESDE ACA EL FLUJO PARA RETOMAR CON LA AUTENTICACION DE SOYYO @JULIAN
          },
          error: async (error: any) => {
            this._loaderService.hide();
            this.validatePerson.set(true);
          }
        });
      });

  }

  closeScreenError(){
    this.showError.set(false);
    this.disabledButton = false;
  }

  proceedToNextStep() {
    const STEP_CONFIRM_DATA_IN_CURRENT_MODAL = 1;
    const STEP_SHOW_CAMERA_IN_CURRENT_MODAL = 2;

    if (this.currentStep === STEP_CONFIRM_DATA_IN_CURRENT_MODAL ) {
      this.onSaveData()
      this.currentStep = STEP_SHOW_CAMERA_IN_CURRENT_MODAL;
    } else if (this.currentStep === STEP_SHOW_CAMERA_IN_CURRENT_MODAL) {
      this.showModal.set(false);
      this.currentStep = STEP_CONFIRM_DATA_IN_CURRENT_MODAL;
      this.requestCameraPermission();
    }
  }

  async verifyBlockIdentification() {
    const identification = this.form.get('identification')?.value;

    try{
      await this._securityService.checkBlockIdentification(identification).subscribe({
        next: (response: any) => {
          if(response.data){
          } else {
            this.titleError = 'Error al validar tus datos';
            this.descriptionError = ' Ha ocurrido un problema al validar tus datos. Por favor, comunícate con tu asesor o acércate a una oficina para resolver este inconveniente. '
            this.showError.set(true);
          }
        },error:(error: any) => {
          console.error("ERROR: ", error)
        }
      });
    } catch (error) {
    }
  }

  private requestCameraPermission(): void {
    if (!navigator.mediaDevices?.getUserMedia) {
      console.error('❌ Media API not supported in this browser');
      return;
    }

    if (!navigator.permissions?.query) {
      console.error('❌ Permissions API not supported in this browser');
      return;
    }

    from(
      navigator.permissions.query({ name: 'camera' as PermissionName })
    ).subscribe({
      next: (permissionStatus) => {
        if (permissionStatus.state === 'granted') {
          console.log('✅ Camera permission already granted');
          this.checkPercentages();
        } else if (permissionStatus.state === 'prompt') {
          this.requestExplicitPermission();
        } else {
          this.showAlert.set(true)
        }
      },
      error: () => {
        this.requestExplicitPermission();
      }
    });
  }



  sendBirthdate() {
    this.showBirthdateModal.set(false);
  }

  private requestExplicitPermission(): void {
    navigator.mediaDevices.getUserMedia({ video: true })
      .then(stream => {
        stream.getTracks().forEach(track => track.stop());
        console.log('✅ Camera permission granted');
          this.checkPercentages();
      })
      .catch(error => {
        const errorMessage = this.getErrorMessage(error);
        this.showAlert.set(true);
        console.log(`❌ ${errorMessage}`);
      });
  }

  async onSubmitOlimpia(): Promise<void> {
    if(this.hasValidationPerson) {
      if(!this.canContinue){
        return;
      }
      this.next();
      return;
    }

    const identification = this.form.value.identification;
    const email = this.form.value.email;
    const phone = this.form.value.phone;
    const fullname = this.form.value.fullname;
    const identificationType = this.form.value.identificationType;
    const birthday = this.form.value.birthday;
    const cityBorn = this.form.value.cityBorn;
    const nationalityId = this.form.value.nationalityId;
    let documentType = 'CC';
    switch(identificationType) {
      case '1':
        documentType = 'CC';
        break;
      case '2':
        documentType = 'CE';
        break;
      case 1:
        documentType = 'CC';
        break;
      case 2:
        documentType = 'CE';
        break;
      default:
        documentType = 'CC';
        break;
    }
    this.canContinue = false;
    try {
      await this.saveData(identificationType, identification, email, phone, birthday);
    } catch (error: any) {

      if(error?.error?.err == 'nationality is blocked'){
        this.canContinue = false;
        this.failMessage('A007-F: No se puede realizar su actualización por este canal, por favor acérquese a una oficina o comuníquese con su asesor...');
        this.saveLog('Error', '00-nationality is blocked', null);
        this.ngOnInit();
        return;
      }

    }
    this._loaderService.show('Redirigiendo a validación, por favor espere...');
    try {
      this.olimpiaService.getValidation(identificationType, identification, email, phone).subscribe({
        next: async (response: any) => {
          const data = response.data;
          this.processGuid = data.procesoConvenioGuid
          this.validationOlimpiaUrl = this.sanitizer.bypassSecurityTrustResourceUrl(data.url);
          this._loaderService.hide();
          this.showOlimpiaSignal.set(true);
          this.startInterval();
        },error: async (error: any) => {
          console.log(error);
        }
      });
    } catch (error) {
      console.log(error);
    }
  }

  startInterval() {
    setTimeout(() => {
      this.intervalId = setInterval(() => {
        this.olimpiaService.verifyValidation(this.processGuid).subscribe({
          next: async (response: any) => {
            const data = response.data;
            if(data.finalizado || data.cancelado){
              this.hideOlimpia();
              if(data.aprobado) {
                this.replicateLastOnboarding();
                this.showWowSignal.set(true);
              } else {
                this.failMessage('116: Autenticación incorrecta, intente de nuevo, acérquese a una oficina o comuníquese con su asesor...');
              }
            }
          },error: async (error: any) => {
            console.log(error);
          }
        });
      }, 10000);
    }, 60000);
  }

  private getErrorMessage(error: DOMException): string {
    switch (error.name) {
      case 'NotAllowedError':
        return 'Camera permission denied by user';
      case 'NotFoundError':
        return 'No camera device found';
      case 'NotReadableError':
        return 'Camera is not available or being used by another application';
      case 'OverconstrainedError':
        return 'Cannot satisfy the requested constraints';
      case 'SecurityError':
        return 'Camera permission is disabled for security reasons';
      case 'AbortError':
        return 'Permission request was aborted';
      default:
        return `Error requesting permission: ${error.message}`;
    }
  }

  toggleFaceGuide() {
    this.showFaceGuide.update(value => !value);
  }
}
